<template>
  <nav class="header-banner__tab-group">
    <button type="button" v-for="(step, index) in this.steps" :key="step.index" @click="sendStep(index)"
      :class="['header-banner__tab-item', (currentStep === step.index) ? activeClass : '', step.enabled ? enabledClass : disabledClass, step.completed ? completeClass : '']">
      <!-- For a future proofed design check if a function can be passed to determine the displayed output making it a better re-usable component -->
      <span class="header-banner__tab-label">{{step.title}}</span>
    </button>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    /*
     * steps must been an array of objects; each containing:
     * id (int), name (string), enabled (bool), complete (bool)
     *
     */
    steps: {
      type: Array,
      required: true
    },
    // current step is the ID of the current step
    currentStep: {
      type: Number,
      required: true
    }
  },
  data: function () {
    // each class for ease of change is a data element
    return {
      disabledClass: 'disabled',
      enabledClass: 'valid',
      activeClass: 'selected',
      completeClass: 'complete'
    }
  },
  methods: {
    //event handler when the tabs are clicked
    sendStep(data) {
      this.$emit('goTo', data)
    }
  }
}
</script>
